var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container"},[_c('fadeInAnimation',[_c('div',{staticClass:"part-name"},[_vm._v(_vm._s(_vm.partName))])]),_c('div',{staticClass:"title-content"},[_c('springText',{staticClass:"item-title",attrs:{"text":_vm.title}})],1),_c('fadeInAnimation',[_c('div',{staticClass:"sub-title"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }